import type { QuizSection } from '@repo/types/quiz';

import { Tiptap } from '@/components/ui/tiptap-editor';
import { quizExtensionSet } from '@/lib/tiptap-extensions-sets';

import { QuestionContent } from '.';

interface SectionContentProps {
  section?: QuizSection;
  sectionIndex: number;
  showMarked: boolean;
}

export default function SectionContent(sectionContentProps: SectionContentProps) {
  const { section, sectionIndex, showMarked } = sectionContentProps;
  return (
    <div className="bg-surface-primary-hover grow overflow-auto">
      <div className="space-y-2 p-4">
        <h5 className="text-text-primary text-xl font-semibold">Sekcja {sectionIndex + 1}</h5>
        {section?.content && <Tiptap extensions={quizExtensionSet} editable={false} content={section.content} />}
      </div>
      <div className="space-y-8 p-4">
        {section?.questions.map((question, index) => (
          <QuestionContent key={index} question={question} questionIndex={index} sectionIndex={sectionIndex} showMarked={showMarked} />
        ))}
      </div>
    </div>
  );
}
